<script lang="ts" setup>
defineProps<{
  list: Array<{
    label: string
    value: string
    class: string
  }>
}>()

const emits = defineEmits(['change'])
const tab = defineModel()

function change(value: string) {
  tab.value = value
  emits('change', value)
}
</script>

<template>
  <div class="flex font-medium rounded-lg cursor-pointer bg-pageTertiary h-[34px] p-[1px] text-textTertiary">
    <div
      v-for="i in list" :key="i.value" class="flex items-center justify-center h-full px-3 rounded-lg w-1/2" :class="{
        [i.class]: i.value === tab,
      }" @click="change(i.value)"
    >
      {{ i.label }}
    </div>
  </div>
</template>
